import React, { useEffect } from 'react';
import Automobilitybanner from './Automobilitybanner';
import MobilitypageData from './MobilitypageData';
import Autmptivemobilityverticaltab from './Autmptivemobilityverticaltab';
import Automotivesecondverticaltab from './Automotivesecondverticaltab';
import Automotivethirdtab from './Automotivethirdtab';
import CregotAutmotivemobility from './CregotAutmotivemobility';
import Automotivemobilecrigot from './Automotivemobilecrigot';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Itrequestform from './Itrequestform';
import Footer from './Footer';

const AutomotiveandMobility = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Scroll to top when component mounts

  return (
    <div style={{ backgroundColor: '#fff', fontFamily: '"Helvetica Neue", sans-serif' }}>
      <Automobilitybanner />
      <MobilitypageData />
      <Autmptivemobilityverticaltab />
      <Automotivesecondverticaltab />
      <Automotivethirdtab />
      <CregotAutmotivemobility />

      {/* <div className='mobile-crigot'>
        <Automotivemobilecrigot />
      </div> */}

      {/* <AerospaceInsightsCards /> */}
      <br />
      <Itrequestform />

      <div style={{ marginTop: '-60px' }}>
        <Footer />
      </div>

      {/* Apply font-family globally within this component */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
           
          }
            
        `}
      </style>
    </div>
  );
};

export default AutomotiveandMobility;
